import { invoke } from '@vueuse/core'
import type { RouteLocationNormalized } from '#vue-router'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
  if (
    import.meta.server ||
    ['index', 'register'].includes(to.name!.toString()) ||
    to.path!.startsWith('/settings')
  )
    return

  const { hasPaymentKeys } = storeToRefs(useAuthStore())

  invoke(async () => {
    await until(hasPaymentKeys).toBe(false)

    // const { openProviderIfKeysNotAdded } = useUtilsStore()
    // setTimeout(() => openProviderIfKeysNotAdded(), 100)
  })
})
